import { ShieldCheck, FileCheck2 } from "lucide-react";

const ITEMS = [
  { title: "3-Year Labor Warranty", text: "Every system installed by Central Air Depot includes a 3-year labor warranty, standard." },
  { title: "Daikin: 12-Year Parts & Compressor", text: "Daikin systems include a 12-year parts and compressor warranty — among the strongest in the industry." },
  { title: "All Other Brands: 10-Year Parts & Compressor", text: "Goodman, Bryant, Rheem, Trane, Carrier, American Standard, Ruud and Coldflow systems include a 10-year parts and compressor warranty." },
];

export const WarrantyBlock = () => (
  <section data-testid="warranty-block" className="bg-brand-ink text-white">
    <div className="max-w-7xl mx-auto px-4 py-16">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-ice mb-2">Warranty Protection</p>
      <h2 className="text-2xl sm:text-3xl tracking-tight font-black">Installed right, backed for years</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        {ITEMS.map((w, i) => (
          <div key={w.title} data-testid={`warranty-item-${i}`} className="bg-white/5 border border-white/10 p-6 rounded-sm">
            <ShieldCheck className="w-7 h-7 text-brand-ice mb-3" />
            <h3 className="font-heading font-bold text-lg">{w.title}</h3>
            <p className="text-sm text-blue-100 mt-2 leading-relaxed">{w.text}</p>
          </div>
        ))}
      </div>
      <p data-testid="warranty-permit-note" className="flex items-start gap-2 text-sm text-blue-100 mt-6">
        <FileCheck2 className="w-5 h-5 text-brand-ice shrink-0 mt-0.5" />
        All AC replacements include permit handling as required by South Florida code — we pull and close the permit so you don't have to.
      </p>
    </div>
  </section>
);
